import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy">
      <div className="privacy-container">
        <section className="privacy-hero">
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </section>

        <section className="privacy-content">
          <div className="privacy-section">
            <h2>Introduction</h2>
            <p>
              Chester's Chicken ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your 
              information when you visit our website or use our mobile application.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Register for an account</li>
              <li>Place an order</li>
              <li>Contact us through our website or app</li>
              <li>Subscribe to our newsletter or promotional communications</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Delivery address</li>
              <li>Payment information</li>
            </ul>

            <h3>Automatically Collected Information</h3>
            <p>
              When you access our website or app, we may automatically collect certain information 
              about your device, including information about your web browser, IP address, time zone, 
              and some of the cookies that are installed on your device.
            </p>
          </div>

          <div className="privacy-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Process and fulfill your orders</li>
              <li>Communicate with you about your orders and our services</li>
              <li>Send you promotional materials and updates (with your consent)</li>
              <li>Improve our website and mobile app</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Detect and prevent fraud or other illegal activities</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Information Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share 
              your information in the following circumstances:
            </p>
            <ul>
              <li>
                <strong>Service Providers:</strong> We may share your information with third-party 
                service providers who perform services on our behalf, such as payment processing, 
                delivery services (DoorDash, Uber Eats, Grubhub), and data analytics.
              </li>
              <li>
                <strong>Legal Requirements:</strong> We may disclose your information if required to 
                do so by law or in response to valid requests by public authorities.
              </li>
              <li>
                <strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale 
                of assets, your information may be transferred as part of that transaction.
              </li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal 
              information against unauthorized access, alteration, disclosure, or destruction. However, 
              no method of transmission over the Internet or electronic storage is 100% secure, and we 
              cannot guarantee absolute security.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Your Rights</h2>
            <p>Depending on your location, you may have the following rights regarding your personal information:</p>
            <ul>
              <li>The right to access your personal information</li>
              <li>The right to correct inaccurate information</li>
              <li>The right to delete your personal information</li>
              <li>The right to object to processing of your personal information</li>
              <li>The right to data portability</li>
              <li>The right to withdraw consent</li>
            </ul>
            <p>
              To exercise these rights, please contact us using the contact information provided below.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our website and 
              store certain information. You can instruct your browser to refuse all cookies or to 
              indicate when a cookie is being sent. However, if you do not accept cookies, you may 
              not be able to use some portions of our website.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under the age of 13. We do not knowingly 
              collect personal information from children under 13. If you become aware that a child 
              has provided us with personal information, please contact us, and we will take steps 
              to delete such information.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page and updating the "Last updated" date. 
              You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <ul>
              <li><strong>Phone:</strong> <a href="tel:4134177982" className="privacy-link">(413) 417-7982</a></li>
              <li><strong>Address:</strong> 1116 St James Ave, Springfield, MA 01104</li>
              <li><strong>Email:</strong> Contact us through our <a href="/contact" className="privacy-link">Contact Us</a> page</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;

